import React, { useState, useEffect, useMemo } from 'react';
import { CircularProgress, Skeleton } from '@mui/material';
import { useStyles } from './ClientContactsPage.styles';
import { useClientContactData } from './hooks/useClientContactData';
import { SubProjectTable } from './components/SubProjectTable/SubProjectTable';
import { ClientProjectData } from '@modules/EvaluationModule/interfaces/ClientProjectData';
import classNames from 'classnames';
import { DataState } from '@shared/enums/DataState';
import { DataErrorView } from '@shared/components/DataErrorView';

export const ClientContactsPage: React.FC = () => {
  const styles = useStyles();
  const clientContactData = useClientContactData();
  const [choosenProject, setChoosenProject] = useState<ClientProjectData | null>(null);
  
  const clientList = useMemo(() => clientContactData.data ? clientContactData.data.map((project) => project.name) : [], [clientContactData.data]);

  useEffect(() => {
    if (clientList.length > 0 && !choosenProject && clientContactData.data) {
      setChoosenProject(clientContactData.data[0]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientList]); // Using project names as dependency to avoid unnecessary re-renders

  const isRejected = clientContactData.state === DataState.Rejected;
  const isLoading = clientContactData.state === DataState.Pending;

  const handleClickOnTeamRow = (project: ClientProjectData) => {
    setChoosenProject(project);
  };

  const SKELETON_WIDTHS = ['75%', '60%', '85%', '70%', '55%', '80%', '65%'];

  if (isRejected) {
    return <DataErrorView />;
  }

  return (
    <div className={styles.root}>
      <div className={styles.projectListContainer}>
        <div className={styles.projectList}>
          {isLoading ? (
            <>
              {SKELETON_WIDTHS.map((width, i) => (
                <div key={i} className={styles.projectItem}>
                  <Skeleton variant="text" width={width} />
                </div>
              ))}
            </>
          ) : (
            clientContactData.data?.map((project, i) => (
              <div
                key={i}
                className={classNames(styles.projectItem, {
                  [styles.chossenProjectItem]: project.name === choosenProject?.name,
                })}
                onClick={() => handleClickOnTeamRow(project)}
              >
                {project.name}
              </div>
            ))
          )}
        </div>
      </div>
      {choosenProject ? (
        <SubProjectTable choosenProject={choosenProject} />
      ) : (
        <div className={styles.loaderContainer}>
          <CircularProgress size={32} />
        </div>
      )}
    </div>
  );
};
